// extracted by css-extract-rspack-plugin
export default {"lastEditInfoContainer":"MarkdownLastEditedBy-module__lastEditInfoContainer__zi8GuG4","mutedEditorLink":"MarkdownLastEditedBy-module__mutedEditorLink__YCjyfH9"};